setTimeout(function () {
  console.log("Hello World");
  var products = regproducts;
  console.log("Regproducts", products);
  var btns = {
    openModal: $('.teeSubs--getStarted--button'),
    continue: $('.teeSubs--continue--button'),
    subscriptionTypeBtn: $('[data-subscription-type]'),
    sizeBtn: $('[data-subscription-size]'),
    subscriptionLengthBtn: $('[data-subscription-length]'),
    addToCartBtn: $('[data-add-to-cart]'),
    closeModal: $('.teeSubs--close-modal'),
    nav: $('.teeSubs--modal .menu .number'),
  }

  var vars = {
    body: $('body'),
    modal: $('.teeSubs--modal'),
    radio: $('input[type="radio"]'),
    typeReview: $('.subscription-type-review'),
    sizeReview: $('.subscription-size-review'),
    lengthReview: $('.subscription-length-review'),
  }

  var resetBtns = function() {
    btns.addToCartBtn.prop('disabled', false);
    btns.continue.prop('disabled', true);
    // vars.radio.prop('checked', false);

    $('.order-note--button').prop('disabled', false);
  }

  resetBtns();

  btns.openModal.on('click', function() {
    vars.modal.addClass('in');
    vars.modal.show();
    vars.body.addClass('teeSubs-modal');
  });

  btns.closeModal.on('click', function(e) {
    e.preventDefault();
    vars.modal.removeClass('in');
    vars.modal.addClass('out');
    setTimeout(function() {
      vars.modal.addClass('in');
      vars.modal.removeClass('out');
      vars.modal.hide();
      vars.body.removeClass('teeSubs-modal');
    }, 500);
  });

  vars.radio.on('change', function () {
    const _parent = $(this).parents('.teeSubs--section');
    _parent.find('button').prop('disabled', false);
  });

  btns.subscriptionTypeBtn.on('click', function() {
    subscription.typeValue = $('.teeSubs--subscription-type input[type="radio"]:checked').val();
    subscription.type = $('.teeSubs--subscription-type input[type="radio"]:checked').data('value');
    
    let variants = [];
    console.log("products:", products);
    $.each(products, function(index, variant) {
      $.each(variant, function(key, item) {
        if (item.availability) {
          if(key in variants) {
            variants[key] += 1;
          } else {
            variants[key] = 1;
          }
        }
      });
    });
    $('.teeSubs--size input[type="radio"]').each(function(index) {
      let value = $(this).data('value');
      console.log(value, variants);
      if (value in variants) {
        $(this).prop('disabled', false);
      } else {
        $(this).prop('disabled', true);
      }
    });
  });

  btns.sizeBtn.on('click', function() {
    subscription.sizeValue = $('.teeSubs--size input[type="radio"]:checked').val();
    subscription.size = $('.teeSubs--size input[type="radio"]:checked').data('value');
    $('.teeSubs--subscription-length input[type="radio"]').each(function(index) {
      let value = $(this).data('value');
      if (value in products) {
        if(subscription.size in products[value]) {
          $(this).prop('disabled', false);
          $(this).next().find('.teeSubs-amount').html($.trim(Shopify.formatMoney(products[value][subscription.size].price, $('body').data('money-format'))));
        } else {
          $(this).prop('disabled', true);
        }
      }
      else {
        $(this).prop('disabled', true);
      }
    });
  });

  btns.subscriptionLengthBtn.on('click', function() {
    subscription.lengthValue = $('.teeSubs--subscription-length input[type="radio"]:checked').val();
    subscription.length = $('.teeSubs--subscription-length input[type="radio"]:checked').data('value');
  });

  btns.nav.on('click', function() {
    if ($(this).hasClass('selected') || $(this).hasClass('selected')) return false;
    var step = $(this).data('step');
    $('.teeSubs--section').removeClass('show');
    $('.teeSubs--section[data-section="'+step+'"]').addClass('show');
    setNav();
    resetBtns();
  });

  btns.continue.on('click', function() {
    const _parent = $(this).parents('.teeSubs--section');
    let section = _parent.data('section');
    _parent.removeClass('show');
    $('.teeSubs--section[data-section="'+ (++section) +'"]').addClass('show');

    if(subscription.type == 'gift'){
      $('.teeSubs--review').attr('data-section', '5')
      $('.teeSubs--note').attr('data-section', '4')

      $('.review-nav').attr('data-step', '5')
      $('.review-nav').text('5')

      $('.order-note-nav.number').attr('data-step', '4')
      $('.order-note-nav.number').text('4')
      $('.order-note-nav.number').css('display','flex');
      $('.order-note-nav.line').css('display','block');

      $('.gifts-products').show()
      $('.regular-products').hide()
      
    }else {
      $('.gifts-products').hide()
      $('.regular-products').show()
    }

    if( subscription.type == 'gift' ){
      products = giftproducts;
    }else {
      products = regproducts;
    }

    setNav();
    resetBtns();
    if (section==4) {

      

      if (subscription.length in products) {
        if (subscription.size in products[subscription.length]) {
          var variant = products[subscription.length][subscription.size];
          subscription.varid = variant.varid;
          subscription.selling_plan = variant.selling_plan
          if(variant.availability) btns.addToCartBtn.prop('disabled', false);
        }
      }

      vars.typeReview.text(subscription.typeValue);
      vars.sizeReview.text("Shirt size: " + subscription.sizeValue);
      vars.lengthReview.text("Duration: " + subscription.lengthValue);
    }
  });

  function rerenderCartPopup() {
    const popup = document.querySelector('.hs-site-cart-popup-layout');
    if (!popup) return;

    const clone = popup.cloneNode(true);
    popup.parentNode.replaceChild(clone, popup);
  }

  btns.addToCartBtn.on('click', function() {
    var note = $('#note').val();
    if (subscription.varid) {
      var data = {
          id: subscription.varid,
          quantity: 1,
          "selling_plan": subscription.selling_plan,
          properties: {
            "shipping_interval_frequency": 1,
            "shipping_interval_unit_type": "Months" 
          }, 
          attributes: {
            'Subscription Type': subscription.typeValue,
            'note': note
          }
        }
      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify(data)
      };
      fetch('/cart/clear.js')
      .then(function(response) {
        return response.json();
      })
      .then(function() {
        fetch('/cart/add.js', request)
          .then(function(response) {
            return response.json();
          })
          .then(
            function(cart) {
              rerenderCartPopup();              
              var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2];
              var paramDomain = 'myshopify_domain={{ shop.permanent_domain }}';
              try {
                var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
              } catch (err) {
                var paramLinker = '';
              }
              var paramCustomer =
                '{% if customer %}&customer_id={{ customer.id }}&customer_email={{ customer.email }}{% endif %}';
            //  window.location = "/cart";

            }
          )
          .catch(
            function() {
              this._showCartError(null);
            }
          );
      })
    }
  });

  var setNav = function() {
    $('.menu .number').removeClass('selected disabled');
    var $sections = $('.teeSubs--section');
    var number = 4;
    $sections.each(function(index) {
      index++;
      if($(this).hasClass('show')) {
        number = index;
        console.log(index)
        if(subscription.type != 'gift' && index == 5){
          index = 4;
        }

        $('.menu .number[data-step="'+index+'"]').addClass('selected');
      } else if(index > number) {
        $('.menu .number[data-step="'+index+'"]').addClass('disabled');
      }
    });
  }

}, 1000);

function monitorFormAction() {
  let currentForm = null; // Keep track of the most recently detected form

  const checkForm = () => {
    // Look for the target form on the page
    const form = document.querySelector('form.pf-form-processed');

    // If a new matching form appears, set up a watcher for it
    if (form && form !== currentForm) {
      currentForm = form;

      // Create an observer to watch for attribute changes on this form
      new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          // Only react when the "action" attribute changes
          if (m.attributeName === "action") {
            const action = form.getAttribute("action");

            // Do something when the form’s action becomes "/checkout"
            if (action === "/checkout") {
              // Your logic goes here
            }
          }
        });
      }).observe(form, {
        attributes: true,          // Observe attribute changes
        attributeFilter: ["action"] // Only watch the "action" attribute
      });
    }
  };

  // Watch the entire document for new elements being added (e.g., AJAX-loaded forms)
  new MutationObserver(checkForm).observe(document.body, {
    childList: true, // Watch for direct children added/removed
    subtree: true    // Also watch all descendants
  });

  // Run an initial scan in case the form is already present
  checkForm();
}

// Start monitoring
monitorFormAction();
